/**
 * @generated SignedSource<<b741d5abd592b1d06d1ab95bbdfa62a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateExchangeRateInput = {
  currency?: string | null;
  rate?: number | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createExchangeRateMutation$variables = {
  input: CreateExchangeRateInput;
};
export type createExchangeRateMutation$data = {
  readonly createExchangeRate: {
    readonly exchangeRate: {
      readonly node: {
        readonly id: string;
        readonly currency: string | null;
        readonly rate: number | null;
        readonly isUsed: boolean | null;
        readonly createdAt: string | null;
      } | null;
    } | null;
  } | null;
};
export type createExchangeRateMutation = {
  variables: createExchangeRateMutation$variables;
  response: createExchangeRateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateExchangeRatePayload",
    "kind": "LinkedField",
    "name": "createExchangeRate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ExchangeRateTypeEdge",
        "kind": "LinkedField",
        "name": "exchangeRate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ExchangeRate",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currency",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isUsed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createExchangeRateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createExchangeRateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "843438f5a9c13f67d377d64d9830775d",
    "id": null,
    "metadata": {},
    "name": "createExchangeRateMutation",
    "operationKind": "mutation",
    "text": "mutation createExchangeRateMutation(\n  $input: CreateExchangeRateInput!\n) {\n  createExchangeRate(input: $input) {\n    exchangeRate {\n      node {\n        id\n        currency\n        rate\n        isUsed\n        createdAt\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7833680534cf56fb5e9f144c514093f5";

export default node;
